// @ts-strict-ignore
import React, { useEffect } from 'react';
import moment from 'moment-timezone';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { angularComponent } from '@/hybrid/core/react2angular.util';
import { bindingsDefinition, prop } from '@/hybrid/core/bindings.util';
import { isValidCapsule } from '@/hybrid/tools/manualCondition/conditionFormula.service';
import { useFlux } from '@/hybrid/core/hooks/useFlux.hook';
import { Capsule } from '@/hybrid/utilities/datetime.constants';
import { DateTimeRange, RangeField } from '@/hybrid/core/DateTimeRange.molecule';
import { sqWorksheetStore } from '@/core/core.stores';

const capsuleInputBindings = bindingsDefinition({
  setCapsuleInputValidStatus: prop.optional<(isValid: boolean) => void>(),
  onChange: prop.optional<(capsuleWindow: Capsule) => void>(),
  trackInformation: prop.optional<string>(),
  trackAction: prop<string>(),
  trackCategory: prop<string>(),
  dateFormat: prop.optional<string>(),
  capsuleWindow: prop<Capsule>(),
});

export const CapsuleInput: SeeqComponent<typeof capsuleInputBindings> = (props) => {
  const {
    setCapsuleInputValidStatus,
    capsuleWindow = {
      startTime: moment().subtract(1, 'hour').valueOf(),
      endTime: moment().valueOf(),
      properties: [],
    },
    onChange,
    trackInformation,
    trackAction,
    trackCategory,
    dateFormat,
  } = props;

  const { timezone } = useFlux(sqWorksheetStore);

  const { t } = useTranslation();

  useEffect(() => {
    setCapsuleWindowStatus(isValidCapsule(capsuleWindow));
  }, []);

  const setCapsuleWindow = (capsuleWindow: RangeField<moment>) => {
    const capsule = {
      ...capsuleWindow,
      startTime: capsuleWindow.start.valueOf(),
      endTime: capsuleWindow.end.valueOf(),
    };
    _.isFunction(onChange) && onChange(capsule);
    setCapsuleWindowStatus(isValidCapsule(capsule));
  };

  const setCapsuleWindowStatus = (isValid) => {
    _.isFunction(setCapsuleInputValidStatus) && setCapsuleInputValidStatus(isValid);
  };

  return (
    <div className="flexRowContainer">
      <div className="flexColumnContainer flexSpaceAround mb5">
        <span className="text-bold">{t('CAPSULE_INPUT_DATE_TIME_LABEL')}</span>
        <span className="text-bold">{t('CAPSULE_INPUT_DATE_TIME_LABEL')}</span>
      </div>
      <div className="flexColumnContainer text-center flexCenter">
        <DateTimeRange
          startTime={moment(capsuleWindow.startTime)}
          endTime={moment(capsuleWindow.endTime)}
          onChange={setCapsuleWindow}
          dateFormat={dateFormat}
          timezone={timezone}
          hideTimezone={true}
          trackCategory={trackCategory}
          trackAction={trackAction}
          trackInformation={{
            start: `Start. ${trackInformation}`,
            end: `End. ${trackInformation}`,
          }}
          fieldIdentifier={{
            start: 'INVESTIGATE_WINDOW_START',
            end: 'INVESTIGATE_WINDOW_END',
          }}
        />
      </div>
      {capsuleWindow && !isValidCapsule(capsuleWindow) && (
        <p className="help-block sq-text-danger text-center">{t('FORM.START_BEFORE_END')}</p>
      )}
    </div>
  );
};

export const sqCapsuleInput = angularComponent(capsuleInputBindings, CapsuleInput);
